import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { getFormatDate } from "@/helpers/utils";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import TablePagination from "@/components/tables/TablePagination";
import ImageRP from "@/components/ImageRP";
import type { ResourcePaginationHandler, ResourceWhatsNew } from "../types";

const StyledCard = styled(Card)(() => ({
  borderRadius: "var(--radius-container)",
  height: "100%",
}));

const DateLine = styled("div")(({ theme }) => ({
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    left: "0",
    bottom: "-2px",
    width: "9%",
    height: "2px",
    backgroundColor: theme?.palette?.primary?.main,
  },
}));

const Title = styled("div")(() => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitLineClamp: 3,
}));

interface WhatsNewSectionProps {
  whatsNew?: ResourceWhatsNew[];
  totalNewData: number;
  newDataPageIndex: number;
  newDataPageSize: number;
  handleWhatsNewPage: ResourcePaginationHandler;
}

export default function WhatsNewSection({
  whatsNew,
  totalNewData,
  newDataPageIndex,
  newDataPageSize,
  handleWhatsNewPage,
}: WhatsNewSectionProps) {
  const totalCount = Math.ceil(totalNewData / newDataPageSize);
  return (
    <div>
      <section className="rc-section text-center my-4">
        <div className="row my-5 justify-content-center position-relative align-items-stretch">
          {whatsNew &&
            whatsNew.map((u) => {
              return (
                <div className="col-md-4 col-lg-3 mb-4" key={u.id}>
                  <StyledCard>
                    {/* <CardActionArea className={classes.image}> */}
                    <a
                      href={u.new_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="title_url"
                    >
                      <ImageRP
                        src={u.new_img}
                        type="IMG"
                        className="sg-image"
                        alt={u.new_title}
                      />
                    </a>
                    {/* </CardActionArea> */}
                    <CardContent>
                      <DateLine className="d-flex justify-content-start rc-date mt-3">
                        <Typography component="span" className="small">
                          {getFormatDate(
                            u?.new_date ? u?.new_date : u?.createdAt
                          )}
                        </Typography>
                      </DateLine>
                      <Title className="rc-title pt-3">
                        <Typography component="h5" variant="body1">
                          <a
                            href={u.new_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="title_url"
                          >
                            {u.new_title}
                          </a>
                        </Typography>
                      </Title>
                    </CardContent>
                  </StyledCard>
                </div>
              );
            })}
        </div>
        <div className="row d-flex row d-flex justify-content-center paging">
          <TablePagination
            count={totalCount}
            page={newDataPageIndex}
            onChange={handleWhatsNewPage}
            variant="outlined"
            shape="rounded"
            className="float-right"
          />
        </div>
      </section>
    </div>
  );
}
